import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "reactstrap";
import { Link } from 'react-router-dom';
import { ROUTE_CLIENT_CERTIFICATES } from "config/routes";
import { addParam } from 'api/helper';
import { history, store } from 'store/store';
import { hideNotification } from 'store/actions/notification';
import { PRODUCT_GROUPS } from '../../../../config/constants';

const ProductDetailsSection = (props) => {
  const { item } = props;

  const renderProducts = useCallback( () => {
    return item?.items.map( (order, index) => {
      return <tr key={index}>
        <th className="text-nowrap" scope="row">
          <FormattedMessage id="fields.product.name.and.group"
                            values={{
                              product_group: order?.product_group_title,
                              product_name: order?.product_title
                            }}
          />
        </th>
        <td>
          {order?.product?.product_group?.name === PRODUCT_GROUPS.CERTIFICATE.name ||
            order?.product?.product_group?.name === PRODUCT_GROUPS.CERTIFICATE_WITH_AUTH.name ?
            <Link
              key={index}
              to="#"
              onClick={e => {
                e.preventDefault();

                store.dispatch( hideNotification() );
                history.push(
                  addParam( ROUTE_CLIENT_CERTIFICATES, {} ),
                  {
                    orderNumber: item.order_number,
                    orderId: item.id,
                  }
                );
              }}
            >
              {order?.quantity}({order?.um})
            </Link> : <span key={index}>{order?.quantity}({order?.um})</span>
          }
        </td>
      </tr>
    } )
  }, [ item ] );

  if (! item || ! item?.id) {
    return (
      <>
        <Row>
          <Col className="col-4 mt-3">
            <FormattedMessage id="messages.no_data"/>
          </Col>
        </Row>
      </>
    );
  }

  return (
    <>
      <Row className="ml-lg-n3 mr-lg-n3 m-0 order-view">
        <Col className="col-4 mt-3 ">
          <table className="table-bordered table-striped table">
            <tbody>
            {renderProducts()}
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );

}

export { ProductDetailsSection }
